document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("verification-form");
  const responseBox = document.getElementById("response");

  if (!form) return;

  const pageLoadTime = Date.now();

  form.addEventListener("submit", function () {
    document.getElementById("orderNumber").value = document.getElementById("orderNumberInput").value;
    document.getElementById("fullName").value = document.getElementById("fullNameInput").value;
    document.getElementById("email").value = document.getElementById("emailInput").value;
    document.getElementById("phone").value = document.getElementById("phoneInput").value;
    document.getElementById("zip").value = document.getElementById("zipInput").value;
    document.getElementById("confirmed").value = document.getElementById("confirmCheckInput").checked ? "Yes" : "No";
    document.getElementById("timestamp").value = new Date().toISOString();
    document.getElementById("userAgent").value = navigator.userAgent;
    document.getElementById("screenSize").value = window.screen.width + "x" + window.screen.height;
    document.getElementById("platform").value = navigator.platform;
    document.getElementById("language").value = navigator.language;
    document.getElementById("timeOnPage").value = Math.floor((Date.now() - pageLoadTime) / 1000);
    document.getElementById("isMobile").value = /Mobi|Android/i.test(navigator.userAgent) ? "Yes" : "No";

    if (responseBox) {
      responseBox.innerText = "Submitting your verification.";
    }

    setTimeout(function () {
      if (responseBox) {
        responseBox.innerText = "Thank you. Your order verification was submitted successfully and will now be reviewed.";
      }
    }, 800);
  });
});